type ExerciseStatus = "passed" | "in_progress" | "not_started" | "failed";
type TournamentStatus = "in_progress" | "not_started" | "completed";

interface TournamentStatusResult {
  status: TournamentStatus;
  statusText: string;
  buttonText: string;
}

export const exerciseStatusText = (status: ExerciseStatus): string => {
  switch (status) {
    case "passed":
      return "Completed";
    case "in_progress":
      return "Resume";
    case "not_started":
      return "Start";
    case "failed":
      return "Retry";
    default:
      return "Unknown Status";
  }
};

export const calculateTournamentStatus = (
  startDate: string | Date,
  finishDate: string | Date,
  isEnrolled: boolean
): TournamentStatusResult => {
  const now = new Date();
  const start = new Date(startDate);
  const finish = new Date(finishDate);

  const returnVal: TournamentStatusResult = {
    status: "in_progress",
    statusText: "Tournament in Progress",
    buttonText: isEnrolled ? "Unenroll from Tournament" : "Enroll in Tournament",
  };

  // Determine status
  if (start > now) {
    returnVal.status = "not_started";
    returnVal.statusText = "Upcoming Tournament";
  }
  if (finish < now) {
    returnVal.status = "completed";
    returnVal.statusText = "Tournament Completed";
  }

  return returnVal;
};
